import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../estilos/Login.css'; // Ajusta la ruta según tu estructura de carpetas

const Login = () => {
  const [nombre_usuario, setNombreUsuario] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    login(nombre_usuario, password);
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <h1>Noovia</h1>
        <div className="logo">
          <img src="/imagenes/royal-chef.png" alt="Logo" />
        </div>
        <p>Por favor ingrese su usuario y contraseña</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuario"
            value={nombre_usuario}
            onChange={(e) => setNombreUsuario(e.target.value)}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" className="login-button">
            INGRESO
          </button>
        </form>
      </div>
      <div className="login-right">
      <img src="/imagenes/cenard2.png" alt="Hotel" className="hotel-image" />
        <div className="copyright">
          
          <span>© 2025 Noovia. Todos los derechos reservados por Def-Software.</span>
        </div>
      </div>
    </div>
  );
};

export default Login;

